import { createAction, props } from '@ngrx/store'
import { ResellerModel, RequestModel } from '@models/index'

export const searchResellers = createAction(
    '[Resellers Page] Search Resellers',
    props<{ request: RequestModel }>()
)

export const searchResellersSuccess = createAction(
    '[Resellers Page] Search Resellers Success',
    props<{ data: ResellerModel[], total: number }>()
)

export const getResellerById = createAction(
    '[Resellers Page] Get Reseller By Id',
    props<{ request: RequestModel }>()
)

export const getResellerByIdSuccess = createAction(
    '[Resellers Page] Get Reseller By Id Success',
    props<{ reseller: ResellerModel }>()
)

export const createReseller = createAction(
    '[Resellers Page] Create Reseller',
    props<{ request: RequestModel }>()
)

export const createResellerSuccess = createAction(
    '[Resellers Page] Create Reseller Success',
    props<{ reseller: ResellerModel }>()
)

export const searchResellersByQuery = createAction(
    '[Resellers Page] Search Resellers By Query',
    props<{ request: RequestModel }>()
)

export const searchResllersByQuerySuccess = createAction(
    '[Resellers Page] Search Resellers By QuerySuccess',
    props<{ foundResellers: ResellerModel[] }>()
)

export const deleteReseller = createAction(
    '[Resellers Page] Delete Reseller',
    props<{ resellerId: string }>()
)

export const deleteResellerSuccess = createAction(
    '[Resellers Page] Delete Reseller Success',
    props<{ resellerId: string }>()
)

export const editReseller = createAction(
    '[Resellers Page] Edit Reseller',
    props<{ reseller: ResellerModel }>()
)

export const editResellerAvailableLicenses = createAction(
    '[Resellers Page] Edit Reseller Available Licenses',
    props<{ reseller: ResellerModel }>()
)

export const editResellerSuccess = createAction(
    '[Resellers Page] Edit Reseller Success',
    props<{ reseller: ResellerModel }>()
)

export const archiveReseller = createAction(
    '[Resellers Page] Archive Reseller',
    props<{ resellerId: string }>()
)

export const archiveResellerSuccess = createAction(
    '[Resellers Page] Archive Reseller Success',
    props<{ resellerId: string }>()
)

export const selectResellerProfile = createAction(
    '[Resellers Page] Select Reseller Profile',
    props<{ reseller: ResellerModel }>()
)

export const resllersError = createAction(
    '[Resellers Page] Resllers Error',
    props<{ error: string }>()
)

export const searchResellerByBusiness = createAction(
    '[Resellers Page] Search Reseller By Businnes',
    props<{ request: RequestModel }>()
)

export const searchResellerByBusinessSuccess = createAction(
    '[Resellers Page] Search Reseller By Businnes Success',
    props<{ reseller: ResellerModel }>()
)

export const clearSelectedReseller = createAction(
    '[Resellers Page] Clear Selected Reseller',
)